import {
    GET_RECEIPTS, GET_RECEIPT_DETAILS, GET_RECEIPTS_BY_FLAT,
    CREATE_RECEIPT, UPDATE_RECEIPT, DELETE_RECEIPT,
    CLEAR_RECEIPT, BOUNCE_RECEIPT, CLEAR_RECEIPT_STATE,
    GET_OUTSTANDING_DOCUMENTS, CALCULATE_ALLOCATION_COMPONENTS,
    UPDATE_RECEIPT_ALLOCATIONS,
    BULK_UPLOAD_RECEIPTS, CLEAR_RECEIPT_BULK_UPLOAD_STATE,
    BULK_GET_RECEIPT_DETAILS, BULK_CANCEL_RECEIPTS, BULK_BOUNCE_RECEIPTS, BULK_CLEAR_RECEIPTS,
} from '../../index.types'

export function getReceipts(data) {
    return { type: GET_RECEIPTS, data }
}

export function getReceiptDetails(data) {
    return { type: GET_RECEIPT_DETAILS, data }
}

export function getReceiptsByFlat(data) {
    return { type: GET_RECEIPTS_BY_FLAT, data }
}

export function createReceipt(data) {
    return { type: CREATE_RECEIPT, data }
}

export function updateReceipt(data) {
    return { type: UPDATE_RECEIPT, data }
}

export function deleteReceipt(data) {
    return { type: DELETE_RECEIPT, data }
}

export function clearReceipt(data) {
    return { type: CLEAR_RECEIPT, data }
}

export function bounceReceipt(data) {
    return { type: BOUNCE_RECEIPT, data }
}

export function getOutstandingDocuments(data) {
    return { type: GET_OUTSTANDING_DOCUMENTS, data }
}

export function calculateAllocationComponents(data) {
    return { type: CALCULATE_ALLOCATION_COMPONENTS, data }
}

export function updateReceiptAllocations(data) {
    return { type: UPDATE_RECEIPT_ALLOCATIONS, data }
}

export function clearReceiptState() {
    return { type: CLEAR_RECEIPT_STATE }
}

export function bulkUploadReceipts(data) {
    return { type: BULK_UPLOAD_RECEIPTS, data }
}

export function clearReceiptBulkUploadState() {
    return { type: CLEAR_RECEIPT_BULK_UPLOAD_STATE }
}

export function bulkGetReceiptDetails(data) {
    return { type: BULK_GET_RECEIPT_DETAILS, data }
}

export function bulkCancelReceipts(data) {
    return { type: BULK_CANCEL_RECEIPTS, data }
}

export function bulkBounceReceipts(data) {
    return { type: BULK_BOUNCE_RECEIPTS, data }
}

export function bulkClearReceipts(data) {
    return { type: BULK_CLEAR_RECEIPTS, data }
}
